import { useState, useCallback, useEffect } from 'react';
import { allIsTrue } from 'utils/ValidationUtils';

type Escola = {
  [key: string]: {
    [key: string]: string
  };
}

type LanguageValues = {
  [key: string]: string;
}

const getValueTypes = (): string[] => {
  return [
    'edInfantil',
    'ensFundI',
    'ensFundII',
    'ensMedio',
    'eja',
    'especializada',
  ];
};

const useValidationFields = (escolas: Escola, languageValues: LanguageValues, periodoKey: string) => {
  const [sending, setSending] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const periodoIsValid = useCallback((): { status: boolean; error?: string } => {
    const periodo = escolas[periodoKey].periodo;
    if (!periodo || (typeof periodo === 'string' && periodo.trim() === '')) {
      return {
        status: false,
        error: languageValues.erroValidacaoPeriodo,
      };
    }
    return {
      status: true,
    };
  }, [escolas, languageValues, periodoKey]);

  const validateProfAndAlun = useCallback((): boolean => {
    return getValueTypes().every((type) => {
      const profValue = parseInt(escolas[periodoKey][type + 'Prof']);
      const alunValue = parseInt(escolas[periodoKey][type + 'Alun'])
      return !(profValue > 0 && alunValue === 0) && !(alunValue > 0 && profValue === 0);
    });
  }, [escolas, periodoKey]);

  const processing = useCallback(() => {
    return sending || loading;
  }, [sending, loading]);

  const formIsValid = useCallback((): boolean => {
    const validations = [
      periodoIsValid().status,
      validateProfAndAlun(),
    ];
    if (processing() || !allIsTrue(validations)) {
      return false;
    }
    return true;
  }, [validateProfAndAlun, periodoIsValid, processing]);

  useEffect(() => {
    const newErrors: { [key: string]: string } = {};
    getValueTypes().forEach((type) => {
      const profValue = parseInt((escolas[periodoKey][type + 'Prof']));
      const alunValue = parseInt(escolas[periodoKey][type + 'Alun'])
      if (alunValue > 0 && profValue === 0) {
        newErrors[type + 'Prof'] = languageValues.erroValidacaoCampoProf;
      } else {
        newErrors[type + 'Prof'] = '';
      }
      if (profValue > 0 && alunValue === 0) {
        newErrors[type + 'Alun'] = languageValues.erroValidacaoCampoAlun;
      } else {
        newErrors[type + 'Alun'] = '';
      }
    });
    setErrors(newErrors);
  }, [escolas, languageValues, periodoKey]);

  return {
    errors,
    loading,
    sending,
    setSending,
    setLoading,
    validateProfAndAlun,
    formIsValid,
    processing,
    periodoIsValid,
  };
};

export default useValidationFields;